import { useState } from 'react'

import { crawlerClient } from '@/services/crawler'
import type { CrawlerJobId } from '@/types'

export const useCrawlerRemoveJob = () => {
  const [loading, setLoading] = useState<boolean>(false)

  const remove = async (jobId: CrawlerJobId) => {
    try {
      setLoading(true)
      await crawlerClient.removeFinishedJob(jobId)
    } catch (e) {
      // biome-ignore lint/suspicious/noConsole: intentional
      console.log(`Error removing job: ${jobId}`, e)
    } finally {
      setLoading(false)
    }
  }

  return { loading, remove }
}
